import type { RelatorioAtividadeDto } from '../relatorios-atividades.types';

export function mapRelatorioListItem(r: any): RelatorioAtividadeDto {
  return {
    ...r,
    dataCriacao: r.criadoEm ? new Date(r.criadoEm).toISOString() : '',
    dataEnvio: r.dataEnvio ? new Date(r.dataEnvio).toISOString() : undefined,
    dataAtualizacao: r.editadoEm ? new Date(r.editadoEm).toISOString() : undefined,
  } as RelatorioAtividadeDto;
}

export function mapRelatorioDetalhe(relatorio: any): RelatorioAtividadeDto {
  return {
    ...relatorio,
    dataCriacao: relatorio.criadoEm ? new Date(relatorio.criadoEm).toISOString() : '',
    dataEnvio: relatorio.dataEnvio ? new Date(relatorio.dataEnvio).toISOString() : undefined,
    dataAtualizacao: relatorio.editadoEm ? new Date(relatorio.editadoEm).toISOString() : undefined,
  } as RelatorioAtividadeDto;
}

export function mapRelatorioComReprovacao(relatorio: any): RelatorioAtividadeDto {
  return {
    ...relatorio,
    dataCriacao: relatorio.criadoEm ? new Date(relatorio.criadoEm).toISOString() : '',
    dataEnvio: relatorio.dataEnvio ? new Date(relatorio.dataEnvio).toISOString() : undefined,
    dataAtualizacao: relatorio.editadoEm ? new Date(relatorio.editadoEm).toISOString() : undefined,
    dataReprovacao: relatorio.dataReprovacao ? new Date(relatorio.dataReprovacao).toISOString() : undefined,
  } as RelatorioAtividadeDto;
}
